import { type TranslationTree } from '@/i18n/types';

export const messages = {
  emailRequired: 'Digite o e-mail de quem vai entrar na equipe',
  emailInvalid: 'Digite um e-mail válido',
  roleRequired: 'Escolha o acesso',
} satisfies TranslationTree;
